import { render, staticRenderFns } from "./ForgotView.vue?vue&type=template&id=2f460ec6"
import script from "./ForgotView.vue?vue&type=script&lang=js"
export * from "./ForgotView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports